(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["page-loader"] && !Shopify.designMode) return;
  try {
    (function() {
    var loader = document.querySelector('[data-page-loader]');
    if (!loader) return;

    var transitionKey = 'chancenlos-page-loader-transition';
    var navigationStarted = false;

    function showLoader() {
      if (navigationStarted) return;
      navigationStarted = true;
      loader.classList.add('is-active');
      loader.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('page-loader-lock');
    }

    function hideLoader() {
      navigationStarted = false;
      loader.classList.remove('is-active');
      loader.classList.add('is-arriving');
      loader.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('page-loader-lock');

      window.setTimeout(function() {
        loader.classList.remove('is-arriving');
      }, 860);
    }

    function markTransition() {
      try {
        sessionStorage.setItem(transitionKey, '1');
      } catch (error) {
        return;
      }
    }

    function consumeTransition() {
      try {
        if (sessionStorage.getItem(transitionKey) !== '1') return false;
        sessionStorage.removeItem(transitionKey);
        return true;
      } catch (error) {
        return false;
      }
    }

    function shouldHandleLink(link, event) {
      if (!link || !link.href) return false;
      if (event.defaultPrevented) return false;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
      if (link.target && link.target !== '_self') return false;
      if (link.hasAttribute('download')) return false;

      var destination = new URL(link.href, window.location.href);
      if (destination.origin !== window.location.origin) return false;
      if (destination.pathname === window.location.pathname && destination.search === window.location.search) {
        return destination.hash === '';
      }

      return true;
    }

    document.addEventListener('click', function(event) {
      var link = event.target.closest('.nav-menu__link, .site-header__logo-link, .site-header-compact__logo-link, .site-header__search-icon-btn, .site-header-compact__search-icon-btn');
      if (!shouldHandleLink(link, event)) return;

      event.preventDefault();
      if (window.closeNavMenu) window.closeNavMenu();
      showLoader();
      markTransition();

      window.setTimeout(function() {
        window.location.href = link.href;
      }, 920);
    });

    document.addEventListener('submit', function(event) {
      var form = event.target.closest('.site-header__search-form, .site-header-compact__search-form');
      if (!form) return;
      if (form.dataset.pageLoaderSubmitting === 'true') return;

      event.preventDefault();
      form.dataset.pageLoaderSubmitting = 'true';
      showLoader();
      markTransition();

      window.setTimeout(function() {
        form.submit();
      }, 920);
    });

    window.addEventListener('pageshow', function() {
      if (!consumeTransition()) {
        hideLoader();
        return;
      }

      navigationStarted = true;
      loader.classList.add('is-active', 'is-arriving');
      loader.setAttribute('aria-hidden', 'false');

      window.setTimeout(hideLoader, 180);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
